import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense } from "react";
const LazyPhoneNumber = lazy(() => import("./PhoneNumber"));
const PhoneNumber = (props) => (_jsx(Suspense, { fallback: null, children: _jsx(LazyPhoneNumber, { ...props }) }));
export default PhoneNumber;
